import type {
  AchievementsType,
  EquipItemType,
  RewardsRankItemType,
} from '@/types'

export const achievements: AchievementsType[] = [
  {
    id: 1,
    imgCard: '/assets/profile/cup.png',
    title: 'First steps',
  },
  { id: 2, imgCard: '/assets/profile/cup.png', title: 'Daily Roller' },
  {
    id: 3,
    imgCard: '/assets/profile/cup.png',
    title: 'Weekend Warrior',
  },
  {
    id: 4,
    imgCard: '/assets/profile/cup.png',
    title: 'Streak Keeper',
  },
]

export const bodyEquip: EquipItemType[] = [
  {
    equipImg: '/assets/profile/equip/body.png',
    part: 'body',
    rarity: 'Basic',
    rewards: 'None',
  },
  {
    equipImg: '/assets/profile/equip/eyes.png',
    part: 'eyes',
    rarity: 'Basic',
    rewards: 'None',
  },
  {
    equipImg: '/assets/profile/equip/ears.png',
    part: 'ears',
    rarity: 'Basic',
    rewards: 'None',
  },
  {
    equipImg: '/assets/profile/equip/armor.png',
    part: 'armor',
    rarity: 'Basic',
    rewards: 'None',
  },
  {
    equipImg: '/assets/profile/equip/mouth.png',
    part: 'mouth',
    rarity: 'Basic',
    rewards: 'None',
  },
]

export const accessories: EquipItemType[] = [
  {
    equipImg: '/assets/profile/equip/helmet.png',
    part: 'Helmet',
    rarity: 'Basic',
    rewards: 'None',
  },
  {
    equipImg: '/assets/profile/equip/neck.png',
    part: 'neck',
    rarity: 'Basic',
    rewards: 'None',
  },
  {
    equipImg: '/assets/profile/equip/vents.png',
    part: 'vents',
    rarity: 'Basic',
    rewards: 'None',
  },
  {
    equipImg: '/assets/profile/equip/visor.png',
    part: 'visor',
    rarity: 'Basic',
    rewards: 'None',
  },
]

export const ranks: RewardsRankItemType[] = [
  {
    rankImg: '/assets/profile/bronze.png',
    text: 'bronze',
    success: true,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'Silver',
    success: false,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'Gold',
    success: false,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'platinum',
    success: false,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'palladium',
    success: false,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'rhodium',
    success: false,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'sapphire',
    success: false,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'emerald',
    success: false,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'ruby',
    success: false,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'diamond',
    success: false,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'blue diamond',
    success: false,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'red diamond',
    success: false,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'pink star',
    success: false,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'black opal',
    success: false,
  },
  {
    rankImg: '/assets/profile/silver.png',
    text: 'crown jewel',
    success: false,
  },
]
